import { RiRestartLine } from '@remixicon/react';
import { format } from 'date-fns';
import { useState } from 'react';
import { sentryCapture } from '../../../helpers/utils';
import { useApi } from '../../../hooks/useApi';
import { SentryError } from '../../../types/enums';
import { Stats } from '../../Icons/Stats';
import ModalStats from '../../Modal/ModalStats';
import Button from '../../ui/button';

interface StatisticsProps {
	scoutId: string;
	playerId: string;
	playerStatsOpen: boolean;
	setPlayerStatsOpen: (stats: boolean) => void;
}

export const StatisticsPick = ({
	scoutId,
	playerId,
	playerStatsOpen,
	setPlayerStatsOpen,
}: StatisticsProps) => {
	const api = useApi();
	const [openModal, setOpenModal] = useState(false);
	const [data, setData] = useState<any>(null);
	const [isLoading, setIsLoading] = useState(false);

	const fetchData = async () => {
		if (playerStatsOpen) return;
		if (!scoutId || !playerId) return;
		setPlayerStatsOpen(true);
		try {
			setIsLoading(true);

			const res = await api.getStatsByPlayerPick(scoutId, playerId);
			if (!res?.success) {
				throw new Error(res.message);
			}

			setData(res);
			setOpenModal(true);
		} catch (error: any) {
			sentryCapture(error, 'fetchScoreboard', SentryError.Error);
		} finally {
			setIsLoading(false);
			setPlayerStatsOpen(false);
		}
	};

	const handleClick = () => {
		setPlayerStatsOpen(false);
		setOpenModal(false);
	};

	return (
		<div className="absolute top-2.5 left-2.5">
			<Button
				variant="icon"
				onClick={(e) => {
					e.stopPropagation();
					fetchData();
				}}
			>
				{isLoading ? (
					<RiRestartLine className="h-4 w-4 animate-spin text-custom-gray1" />
				) : (
					<Stats className="w-[22px] h-[22px] " />
				)}
			</Button>

			<ModalStats
				id={'modalTooltip'}
				open={openModal}
				onClose={handleClick}
				infoIcon=""
			>
				{isLoading ? (
					<div className="flex items-center justify-center">
						<RiRestartLine className="mr-2 h-4 w-4 animate-spin" />
					</div>
				) : (
					data && (
						<div className="flex flex-col gap-3">
							<h2 className="text-black text-center text-lg font-semibold font-bahnschrift leading-7">
								{data.playerName}
							</h2>
							<div className="flex flex-col gap-4">
								{data.statsPlayerByEvent.length > 0 ? (
									data.statsPlayerByEvent.map(
										(item: any, index: number) => (
											<div
												key={index}
												className="pb-4 border-b border-neutral-400 inline-flex gap-2 flex-col justify-between"
											>
												<div className="w-full flex justify-center items-center gap-1">
													<div className="max-[375px]:w-20 w-28 flex justify-end items-center gap-1">
														<div className="text-black text-xs break-words font-normal max-[375px]:w-20 w-28 text-right font-bahnschrift leading-none">
															{item.teamHome.name}
														</div>
														<img
															className="w-5 object-scale-down"
															src={
																item.teamHome
																	.image
															}
															alt={
																item.teamHome
																	.name
															}
														/>
													</div>

													<div className="flex justify-center items-end gap-0.5">
														<span className="text-black text-base font-normal font-bahnschrift leading-none">
															{
																item.teamHome
																	.score
															}
														</span>
														<span className="text-black text-xs font-light font-bahnschrift leading-none">
															x
														</span>
														<span className="text-black text-base font-light  font-bahnschrift leading-none">
															{
																item.teamAway
																	.score
															}
														</span>
													</div>

													<div className="max-[375px]:w-20 w-28 flex items-center gap-1 ">
														<img
															className="w-5 object-scale-down"
															src={
																item.teamAway
																	.image
															}
															alt={
																item.teamAway
																	.name
															}
														/>
														<div className="justify-start max-[375px]:w-20 w-28 break-words text-black  text-xs font-normal font-bahnschrift leading-none">
															{item.teamAway.name}
														</div>
													</div>
												</div>

												<div className="w-full flex flex-row justify-between">
													<div className="flex flex-col justify-center">
														<span className="text-black text-xs font-normal font-bahnschrift leading-none">
															{format(
																new Date(
																	item.startAt
																),
																'dd/MM HH:mm'
															)}
														</span>
													</div>

													<div
														className={
															'flex flex-row text-base font-normal font-bahnschrift leading-none gap-0.5' +
															(item.totalPointsPlayer <
															0
																? ' text-primary'
																: item.totalPointsPlayer >
																  0
																? ' text-green-500'
																: ' text-neutral-400')
														}
													>
														<span>
															{item.statsPlayer
																.length > 0
																? item
																		.statsPlayer[0]
																		.result
																: 0}
														</span>
														<span>
															{item.statsPlayer
																.length > 0
																? Number(
																		item
																			.statsPlayer[0]
																			.result
																  ) > 1
																	? item
																			.statsPlayer[0]
																			.scoutNameSuffix
																	: item
																			.statsPlayer[0]
																			.scoutName
																: ''}
														</span>
													</div>
												</div>

												{/* {item.totalPointsPlayer !== 0 &&
													item.statsPlayer.length >
														0 && (
														<table className="w-full table-auto">
															<thead className="h-6">
																<tr>
																	<th className="text-left self-stretch text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
																		Evento
																	</th>
																	<th className="text-right self-stretch w-16 text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
																		Pontos
																	</th>
																	<th className="text-right self-stretch w-16 text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
																		Vezes
																	</th>
																	<th className="text-right self-stretch w-16 text-[#7A7A7A] text-sm font-medium font-bahnschrift leading-3 tracking-tight">
																		Total
																	</th>
																</tr>
															</thead>
															<tbody>
																{item.statsPlayer.map(
																	(
																		scout: any,
																		index: number
																	) => (
																		<tr
																			key={
																				index
																			}
																		>
																			<td className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
																				{
																					scout.scoutName
																				}
																			</td>
																			<td
																				className={
																					' text-right text-xs font-light font-bahnschrift leading-tight' +
																					(Number(
																						scout.scoutPoint
																					) <
																					0
																						? ' text-primary'
																						: Number(
																								scout.scoutPoint
																						  ) >
																						  0
																						? ' text-green-500'
																						: ' text-neutral-400')
																				}
																			>
																				{scout.scoutPoint <
																				0
																					? scout.scoutPoint
																					: `+${scout.scoutPoint}`}
																			</td>
																			<td className="text-neutral-400 text-right text-xs font-light font-bahnschrift leading-tight">
																				x
																				{
																					scout.result
																				}
																			</td>
																			<td
																				className={
																					'text-right text-xs font-light font-bahnschrift leading-tight' +
																					(Number(
																						scout.totalPoints
																					) <
																					0
																						? ' text-primary'
																						: Number(
																								scout.totalPoints
																						  ) >
																						  0
																						? ' text-green-500'
																						: ' text-neutral-400')
																				}
																			>
																				{scout.totalPoints <
																				0
																					? scout.totalPoints
																					: `+${scout.totalPoints}`}{' '}
																				pts
																			</td>
																		</tr>
																	)
																)}
															</tbody>
														</table>
													)} */}
											</div>
										)
									)
								) : (
									<div className="flex flex-col pt-6 items-center text-center justify-center gap-2">
										<Stats className="w-16 h-16" />
										<p className="text-[#535861] text-xs font-light font-bahnschrift leading-tight">
											Não há dados estatísticos
											disponíveis no momento.
										</p>
									</div>
								)}
							</div>
						</div>
					)
				)}
			</ModalStats>
		</div>
	);
};
